import { type FC, Suspense, lazy, type ComponentProps } from "react";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";
import * as styles from "./styles.css";
import { SelectedList } from "./uiParts/selectedList";
import { type selectedItemProps, type ActionProps } from "./modules";

const SelectModal = lazy(() =>
  retryLazyLoad({
    fn: () => import("./uiParts/selectModal"),
  }),
);

export type ItemProps = {
  initialChecked: boolean;
  value: string;
  text: string;
  hasRecommendedLabel?: boolean;
};

type Props = {
  categoryName: string;
  formName: string;
  formState: selectedItemProps;
  dispatchFormState: React.Dispatch<ActionProps>;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  isShow: boolean;
  items: (ItemProps & ComponentProps<"input">)[];
  handleOnClick: () => void;
  isBiyo?: boolean;
};

export const Presentation: FC<Props> = ({
  categoryName,
  formName,
  formState,
  dispatchFormState,
  setIsShow,
  isShow,
  items,
  handleOnClick,
  isBiyo,
}) => (
  <>
    <SelectedList formState={formState} dispatchFormState={dispatchFormState} />
    <button type="button" className={styles.openModalButton} onClick={() => setIsShow(true)}>
      <i className={`icon-plus-1 ${styles.openModalButtonIcon}`} />
      {categoryName}を追加する
    </button>
    <Suspense fallback={null}>
      <SelectModal
        categoryName={categoryName}
        isShow={isShow}
        onClickClose={() => setIsShow(false)}
        items={items}
        handleOnClick={handleOnClick}
        isBiyo={isBiyo}
      />
    </Suspense>
    <input
      type="hidden"
      name={`form_client_frontend_scout_user_search[${formName}]`}
      id={`form_client_frontend_scout_user_search_${formName}`}
      value={Object.keys(formState).length > 0 ? JSON.stringify(Object.keys(formState)) : ""}
      className="js-search-scoutable-field-disabled-if-value-empty"
    />
  </>
);
